import React from "react";

function LookbackToggle({ value, onChange, options = [], className = "" }) {
  const selectedValue = Number(value);
  const optionValues = React.useMemo(() => {
    const base = options.length > 0 ? options : [value];
    const numeric = base
      .map((option) => Number(option))
      .filter((option) => Number.isFinite(option));
    const unique = Array.from(new Set(numeric));
    return unique.sort((a, b) => a - b);
  }, [options, value]);

  const handleSelect = (option) => {
    if (!onChange || option === selectedValue) {
      return;
    }
    onChange(option);
  };

  if (optionValues.length === 0) {
    return null;
  }

  return (
    <div className={`flex items-center gap-2 ${className}`.trim()}>
      <span className="text-sm font-medium text-slate-600">Lookback</span>
      <div className="flex rounded-full bg-slate-100 p-1">
        {optionValues.map((option) => {
          const isActive = option === selectedValue;
          return (
            <button
              key={option}
              type="button"
              className={`px-3 py-1.5 text-sm font-semibold rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400 focus-visible:ring-offset-2 ${
                isActive
                  ? "bg-white text-violet-700 shadow-sm"
                  : "text-slate-500 hover:text-slate-700"
              }`}
              onClick={() => handleSelect(option)}
              aria-pressed={isActive}
            >
              {option === 1 ? "1 week" : `${option} weeks`}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default LookbackToggle;
